import React from 'react';
import { Box, Button, VStack, Text, HStack, useColorModeValue, Divider, Tooltip } from "@chakra-ui/react";
import { Link, useLocation } from 'react-router-dom';
import {
  FaLayerGroup, FaListAlt, FaFileAlt, FaShoppingBag,
  FaClipboardCheck, FaEdit, FaUserCog, FaBlog, FaTags, FaBullhorn,
} from "react-icons/fa";
import StudentSideBarLayout from '../Student/Layouts/StudentSideBarLayout';
import { useStudentSidebar } from '../Student/Layouts/StudentSidebarContext';

const B2CAdminSideBar = () => {
  const { isCollapsed } = useStudentSidebar();
  const location = useLocation();

  const hoverBg = useColorModeValue("gray.100", "gray.700");

  const renderNavLink = (to: string, label: string, icon: React.ReactElement) => {
    const isActive = location.pathname === to;

    const button = (
      <Button
        as={Link}
        to={to}
        justifyContent={isCollapsed ? "center" : "flex-start"}
        variant="ghost"
        size="sm"
        pl={isCollapsed ? 0 : 4}
        py={5}
        borderRadius="lg"
        bg={isActive ? hoverBg : "transparent"}
        _hover={{ bg: hoverBg }}
        fontWeight={isActive ? "semibold" : "medium"}
        w="100%"
      >
        <HStack spacing={isCollapsed ? 0 : 3}>
          {icon}
          {!isCollapsed && <Text fontSize="sm">{label}</Text>}
        </HStack>
      </Button>
    );

    return isCollapsed ? (
      <Tooltip label={label} placement="right" hasArrow>
        {button}
      </Tooltip>
    ) : button;
  };

  return (
    <StudentSideBarLayout>
      <Box px={isCollapsed ? 1 : 3} py={4} mt={10}>
        <VStack align="stretch" spacing={1}>
          {renderNavLink(`/practice/app/b2c-category-manager`, "Categories", <FaLayerGroup />)}
          <Divider my={1} />
          {renderNavLink(`/practice/app/b2c-qset-category-manager`, "QSet Categories", <FaListAlt />)}
          <Divider my={1} />
          {renderNavLink(`/practice/app/b2c-qset-manager`, "Question Sets", <FaFileAlt />)}
          <Divider my={1} />
          {renderNavLink(`/practice/app/b2c-product-manager`, "Products", <FaShoppingBag />)}
          <Divider my={1} />
          {renderNavLink(`/practice/app/practice-manual-attempt`, "Practice Manual Attempts", <FaEdit />)}
          <Divider my={1} />
          {renderNavLink(`/practice/app/b2c-account-manager`, "Account Management", <FaUserCog />)}
          <Divider my={1} />
          {renderNavLink(`/practice/app/b2c-blog-manager`, "Blog Management", <FaBlog />)}
          <Divider my={1} />
          {renderNavLink(`/practice/app/b2c-coupon-manager`, "Coupon Management", <FaTags />)}
          <Divider my={1} />
          {renderNavLink(`/practice/app/b2c-master-promotion`, "Master Promotion", <FaBullhorn />)}
        </VStack>
      </Box>
    </StudentSideBarLayout>
  );
};

export default B2CAdminSideBar;